import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseModels_Usages_Meters_SmartMeterStatusListResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetMeterStatus = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
};
/**
 * Returns a list of meters and their status with error codes list from the last 5 days
 *
 * @returns ResponseModels_Usages_Meters_SmartMeterStatusListResponseModel Success
 */
export function getMeterStatus(
  { businessUnit, label, customerId, accountId }: GetMeterStatus,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_Meters_SmartMeterStatusListResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/meters/status`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
